import BusinessSchool from '@components/LocalMerchant/BusinessSchool'

export default {
  path: 'businessSchool/:id',
  component: BusinessSchool,
  stat: '商学院/商学院详情页'
}
